import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import draftmanJobApi from '../../APIs/draftman';
import { Button, PageHeader, Tag, Typography } from '../../designComponents';
import Table, { TableDataType } from '../../designComponents/Table';
import { RootState } from '../../store/selectors';
import { humanReadableDate, requestAPI } from '../../utils';
import { DraftJobContainerStyled } from './style';

type Props = {};

const DraftsJob = (_props: Props) => {
  const [search, _setSearch] = useState();
  const navigate = useNavigate();
  const draftsJob = useSelector(
    (state: RootState) => state.draftmanJobsData.data,
  );

  const tableData: TableDataType = {
    headings: [
      {
        key: 'createdDate',
        label: 'Date',
      },
      {
        key: 'jobTitle',
        label: 'Job Title',
      },
      {
        key: 'currency',
        label: 'Currency',
      },
      {
        key: 'price',
        label: 'Price',
      },
      {
        key: 'shippingAddress',
        label: 'Shipping Address',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'actions',
        label: 'Action',
      },
    ],

    body: Array.isArray(draftsJob)
      ? draftsJob?.map((job) => {
        return {
          id: job._id,
          createdDate: humanReadableDate(job?.createdAt),
          jobTitle: job?.title,
          currency: job?.pricingPlan.priceDenom,
          price: job?.pricingPlan.price,
          shippingAddress: job?.shippingAddress,
          status: <Tag>{job?.status}</Tag>,
          actions: (
              <Button onClick={() => navigate(job._id)}>View Details</Button>
          ),
        };
      })
      : [],
  };

  const getDraftsJob = async () => {
    try {
      await requestAPI(draftmanJobApi.getAllDraftmanJob());
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getDraftsJob();
  }, []);
  return (
    <DraftJobContainerStyled>
      <div className="header">
        <PageHeader
          pageTitle={<Typography variant="title">Job List</Typography>}
          handleOnSearchTextChange={() => {}}
          search={search}
          width="200px"
        />
      </div>
      <Table tableData={tableData} />
    </DraftJobContainerStyled>
  );
};

export default DraftsJob;
